class Customer.Group extends Backbone.Model
  defaults:
    code: 0
    description: ''
    type: 'label'

class Customer.GroupCollection extends Backbone.Collection
  model: Customer.Group
  url: '/labels'
